import wkb from '@wifikey/wkb';
import wkr from '@wifikey/wkr';
import Toast  from '../components/toast';

// 为了方便在 pc 浏览器中进行开发
// 这里临时使用 vip 项目的加密参数
const encryptParams = {
  // key: 'yNyPsu!dp1*oDjbL',
  // iv: 'iw7yCmhZnC$9KnZ@',
  key: '3nEG#zJ1P%mOx7q@',
  iv: 'nMu*hzF9@8Tr#z&J',
};

// 这几个pid域名为：https://rights.51y5.net
const PID_LIST = ['66644001', '66644002', '66644021', '66644022'];
wkr.init({
  baseURL: process.env.API_ROOT,
});

let url = '';
let nonAppParams = {};

if (wkb.isWKBrowser) {
  url = '/alps/fa.sec';
} else {
  url = '/alps/fa.ss';
  // 仅在非钥匙环境下生效，用于在需要时模拟钥匙公共参数
  nonAppParams = {
    appId: 'AH0001' || 'A0013' || 'ZMVIP01', platform: 'h5', uhid: 'ff808081444a1f3201444a46472f0904', mapSP: 'b',
  };
}

const request = (pid, data) => {
  const requestData = { ...nonAppParams, ...data, pid };

  // 将所有参数值字符串化，兼容客户端只接收字符串
  try {
    Object.keys(requestData).forEach((key) => {
      if (typeof requestData[key] !== 'string') {
        requestData[key] = String(requestData[key]);
      }
    });
  } catch (error) {
    // pass
  }

  let baseURL;
  PID_LIST.map((res) => {
    if (pid === res) {
      baseURL = process.env.API_RIGHTS_ROOT;
    }
  });

  console.log(`[👆🏻] Request of pid ${pid} with data:`, requestData);
  return wkr.request({
    baseURL,
    url,
    method: 'post',
    data: requestData,
  }, encryptParams)
    .then((res) => {
      if (!res || String(res.retCd) === '0') {
        console.log(`[👇🏻] Response of pid ${pid} with data:`, res);
        return res;
      }
      return Promise.reject(res);
    })
    .catch((error) => {
      const { retCd } = error;
      if (retCd == 'API_ERROR_-109') {
        Toast('服务异常，请稍后重试');
      }

      console.log(`[👎🏻] Request failed of pid ${pid} with error:`, error);

      return Promise.reject(error);
    });
};

export default request;



// WEBPACK FOOTER //
// ./src/lib/request.js